import { useCallback, useMemo } from 'react';

import { useFillColor } from '~extension/icon-library/context/FillColor';
import downloadIcon from '~extension/icon-library/utils/downloadIcon';
import { PlaceholderButton } from '../button/Button';
import { DownloadButton } from '../button/DownloadButton';
import { BackgroundColorPicker } from '../color-picker/BackgroundColorPicker';
import { FillColorPicker } from '../color-picker/FillColorPicker';

type DownloadSvgProps = { icon: Icon };

export const DownloadSvg = ({ icon }: DownloadSvgProps) => {
  const hasSvg = Boolean(icon.svg);
  const { selectedFillColor } = useFillColor();

  const handleDownload = useCallback(() => {
    downloadIcon(icon, { format: 'SVG' }, selectedFillColor);
  }, [icon, selectedFillColor]);

  const size = useMemo(() => {
    if (icon.height && icon.width) {
      return `${icon.width}×${icon.height}`;
    }
    return 'universal';
  }, [icon.height, icon.width]);

  return (
    <>
      <div className={`border-gray border-solid border-0 border-b flex items-center`}>
        <div className={`box-border flex items-center opacity-50 py-0 px-2 text-left select-none w-1/3`}>Size</div>
        <div className={`flex flex-wrap flex-grow px-0 py-px`}>
          <div className={`flex items-center justify-end flex-grow h-8 pr-2 text-right select-none`}>{size}</div>
        </div>
      </div>
      <FillColorPicker disabled={!hasSvg} />
      <BackgroundColorPicker disabled={!hasSvg} />

      {hasSvg ? <DownloadButton label="Download" onClick={handleDownload} /> : <PlaceholderButton />}
    </>
  );
};
